define([
  "jquery",
  "underscore",
  "marionette",
  "views/withdrawal/common_view",
  "forms/withdrawal/krbank_form",
], function ($, _, Marionette, CommonView, BankwireSticpayForm) {
  return CommonView.extend({
    ui: _.extend(CommonView.prototype.ui, {
      amount: "#amount",
      withdrawal: "#withdrawal_btn",
      withdrawal_agree_checkbox: "#withdrawal_agree_checkbox",
    }),
    events: _.extend(CommonView.prototype.events, {
      "change @ui.accountNoSelect": function (e) {
        this.updateFinancial();
      },
      "keyup @ui.amount": "validateAmount",
      "click @ui.withdrawal_agree_checkbox": "onoff_agree_checkbox",
    }),

    initialize: function () {
      this.bindUIElements();
      this.delegateEvents();
      this.form = new BankwireSticpayForm();
      $("#error_amount").text("");
    },

    onoff_agree_checkbox: function (e) {
      const $checkbox = $("#withdrawal_agree_checkbox");

      if ($checkbox.is(":checked")) {
        this.validateAmount();
      } else {
        $("#withdrawal_btn").attr("disabled", true);
      }
    },

    validateAmount: function (e) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(function () {
        const amount = $("#amount").val();
        if (isNaN(amount) || amount === "" || !amount) {
          $("#expected_amount").val("-");
          return;
        }

        $("#error_amount").text("");
        $("#expected_amount").val("-");

        const min_amount = window.min_amount;
        const max_amount = window.max_amount;
        const daily_withdrawal_limit = window.daily_withdrawal_limit;
        const yearly_withdrawal_limit = window.yearly_withdrawal_limit;

        // 1. check min amount
        if (amount < min_amount) {
          $("#expected_amount").text("-");
          $("#withdrawal_btn").attr("disabled", true);
          $("#error_amount").text(
            window.translations.error_krbank_withdrawal_min_amount
          );
          return;
        }

        // 2. check max amount
        if (amount > max_amount) {
          $("#expected_amount").text("-");
          $("#withdrawal_btn").attr("disabled", true);
          $("#error_amount").text(
            window.translations.error_krbank_withdrawal_max_amount
          );
          return;
        }

        // 3. check daily max amount
        if (amount > daily_withdrawal_limit) {
          $("#expected_amount").text("-");
          $("#withdrawal_btn").attr("disabled", true);
          $("#error_amount").text(
            window.translations.error_krbank_withdrawal_daily_limit
          );
          return;
        }

        // 4. check yearly max amount
        if (amount > yearly_withdrawal_limit) {
          $("#expected_amount").text("-");
          $("#withdrawal_btn").attr("disabled", true);
          $("#error_amount").text(
            window.translations.error_krbank_withdrawal_annual_limit
          );
          return;
        }

        $.ajax({
          url: `/rest_withdrawal/calculate_krbank_expected_amount?amount=${amount}`,
          type: "GET",
          success: function (data) {
            // finally return expected amount
            $("#expected_amount").text("₩" + data.expected_krw_amount_format);
            if ($("#withdrawal_agree_checkbox").is(":checked")) {
              $("#withdrawal_btn").attr("disabled", false);
            } else {
              $("#withdrawal_btn").attr("disabled", true);
            }
            return;
          },
        });
      }, 300);
    },
  });
});
